import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
type LinkItem = {
  href: string;
  label: string;
};
type FooterTextProps = {
  title: string;
  links: LinkItem[];
  className?: string;
};
export function FooterText(t0) {
  const $ = _c(10);
  const {
    title,
    links,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== title) {
    t2 = <h2 className="mb-[0.6rem] text-[0.8rem] uppercase tracking-[0.1em] text-muted">{title}</h2>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== links) {
    t3 = links.map(_temp);
    $[2] = links;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <nav><ul className="list-none m-0 p-0">{t3}</ul></nav>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== className || $[7] !== t2 || $[8] !== t4) {
    t5 = <div className={className}>{t2}{t4}</div>;
    $[6] = className;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp(link) {
  return <li key={link.href}><Link href={link.href} className="block py-1 text-ink no-underline transition-colors hover:text-accent">{link.label}</Link></li>;
}